module.exports = __webpack_public_path__ + "media/rbs_bot_map.73bcfbc5.mp4";